import { Center, Text, Icon, HStack, Circle, CenterProps, Box } from '@chakra-ui/react';
import { IoReceipt, IoArrowForward } from 'react-icons/io5';
import { Pointer } from '~/icons';
import { css, keyframes } from '@emotion/react';

export type OrderHeaderNoticeProps = CenterProps & {
  orderNum: number;
  handleNavigateToOrders: () => void;
};

// 訂單進行中通知：會顯示在菜單頁面的上方，下拉之後會換成fixSection的內容去替代
export default function OrderHeaderNotice({
  orderNum,
  handleNavigateToOrders,
  ...props
}: OrderHeaderNoticeProps) {
  const ripple = keyframes`
    from {
      opacity: 1;
      transform: scale(0);
    }
    to {
      opacity: 0;
      transform: scale(3);
    }
  `;

  const translateMove = keyframes`
    0%, 100% {
      transform: translateX(-3px);
    }
    50% {
      transform: translateX(0px);
    }
  `;

  const circle = css`
    animation: ${ripple} 1.5s ease-out infinite;
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin: 0 5px;
    position: relative;
    background-color: #bdfff5;
  `;

  const pointer = css`
    animation: ${translateMove} 1.5s ease-out infinite;

    display: inline-block;
  `;

  return (
    <Center {...props}>
      <HStack
        boxShadow="0px 5px 3px rgba(51, 51, 51, 0.1)"
        bgColor="white"
        py={2}
        spacing={2}
        onClick={handleNavigateToOrders}
        justify="center"
        flex={1}
      >
        <Icon boxSize="1.125rem" color="Secondary600" as={IoReceipt} />
        <Text fontSize="sm" color="Secondary600" fontWeight="bold">
          {`您有${orderNum}筆正在進行中的訂單`}
        </Text>
        <HStack spacing={-3}>
          <Icon boxSize="1.5rem" as={Pointer} zIndex={2} css={pointer} />
          <Box>
            <Circle css={circle} position="absolute" />
            <Circle
              position="absolute"
              mt="-1.2rem"
              ml="0.2rem"
              size="1rem"
              bgColor="#3B9C8D"
              animation="none"
              opacity={0.5}
              zIndex={1}
            />
          </Box>
        </HStack>
      </HStack>
    </Center>
  );
}
